import * as types from "./types";

export const updateAuthInfo = (jwtPayload) => (dispatch) =>
    dispatch({ type: types.UPDATE_AUTH_INFO, payload: jwtPayload });
export const saveUserProfile = (profile) => updateAuthInfo(profile);
export const setWorkspaces = (workspaces) => (dispatch) =>
    dispatch({ type: types.SET_USER_WORKSPACES, payload: workspaces });
export const updateParticularWorkspace = (workspace) => (dispatch) =>
    dispatch({ type: types.UPDATE_PARTICULAR_WORKSPACE, payload: workspace });
